import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import * as api from '../../lib/api';
import FacilityForm from '../../components/admin/FacilityForm';

export default function NewFacilityPage() {
  const navigate = useNavigate();

  const submit = async (body) => {
    const { facility } = await api.adminCreateFacility(body);
    // A facility with no units is not yet a facility. Land on the unit builder
    // rather than a dashboard row that reads "0 units" with no way forward.
    navigate(`/admin/facilities/${facility.public_id}/units/new`, { replace: true });
  };

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Link to="/admin" className="mb-3 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" aria-hidden="true" /> Operations
      </Link>
      <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">New facility</h1>
      <p className="mb-6 mt-1 text-sm text-slate-600">
        It starts unlisted. Add units and set rates first, then publish it.
      </p>
      <FacilityForm mode="create" onSubmit={submit} submitLabel="Create and add units" />
    </div>
  );
}
